<template>
  <div class="sales-modify">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-button
        v-if="canEdit"
        type="primary"
        :disabled="saving"
        style="position: fixed; right: 10px; z-index: 999"
        @click="submit"
      >提交<span v-if="saving">中...</span></el-button>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="销售信息" name="first">
          <div style="display: flex; height: 25%">
            <div style="display: flex; height: 110px">
              <el-form-item v-if="!isNew" label="单据编号" style="width: 290px">
                <el-input :value="form.fBillNo" disabled />
              </el-form-item>
              <el-form-item label="经销商" prop="fDistributor" style="width: 500px">
                <el-input v-model="form.fDistributor" disabled />
              </el-form-item>
              <el-form-item label="印章" prop="fSeal1ID">
                <el-select-ex
                  v-model="form.fSeal1ID"
                  url="Seal/SealEntry"
                  label-field="fName"
                  value-field="fid"
                  @change="sealChange"
                />
              </el-form-item>
              <p style="margin: 0 30px">
                <img
                  v-if="form.fSealUrl"
                  :src="form.fSealUrl"
                  style="height: 100px"
                >
              </p>
            </div>
            <div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 12px;position:absolute;left:30px;top:20%;z-index:1;"
                @click="select"
              >添加</el-button>
            </div>
          </div>
          <el-table
            v-el-table-height-fix
            :data="form.entrys"
            height="75%"
          >
            <el-table-column v-if="canEdit && form.state != '已审核'" width="30">
              <template slot-scope="scope">
                <div class="tools">
                  <el-popconfirm title="是否删除？" @confirm="delRow(scope.$index)">
                    <i slot="reference" class="el-icon-remove-outline" title="删除" />
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="送货单号" prop="fOrderNo" min-width="130" />
            <el-table-column
              label="销售日期"
              :formatter="dateFormat"
              label-class-name="font-color-red"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.fSalesDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  size="small"
                  style="width: 100%"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="购货单位"
              label-class-name="font-color-red"
              min-width="350"
            >
              <template slot-scope="scope">
                <el-select-table2
                  v-model="scope.row.fCustomer"
                  url="SalesRecordManage/SalesRecord/ChoiceCustomerEntry"
                  label-field="fCustomer"
                  search-key="name"
                  :columns="[
                    { prop: 'fCustomer', label: '购货单位' },
                    { prop: 'fAddress', label: '地址' },
                    { prop: 'fName', label: '联系人' },
                    { prop: 'fPhone', label: '电话' },
                  ]"
                  panel-width="70%"
                  @change="fCustomerChange(scope.row, $event)"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="地址"
              label-class-name="font-color-red"
              min-width="250"
            >
              <template slot-scope="scope">
                <el-input v-model="scope.row.fAddress" type="textarea" autosize />
              </template>
            </el-table-column>
            <el-table-column
              label="联系人"
              label-class-name="font-color-red"
              min-width="150"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.fName"
                  style="width: 100%"
                  size="small"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="电话"
              label-class-name="font-color-red"
              min-width="140"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.fPhone"
                  style="width: 100%"

                  size="small"
                />
              </template>
            </el-table-column>
            <el-table-column label="产品编号" prop="fNumber" min-width="110" />
            <el-table-column label="产品名称" prop="ficItem" min-width="140" />
            <el-table-column label="规格型号" prop="fModel" min-width="140" />
            <el-table-column label="单位" prop="fUnit" width="50" />
            <el-table-column label="数量" label-class-name="font-color-red" min-width="100">
              <template slot-scope="scope">
                <el-input-currency v-model="scope.row.fQty" :scale="0" size="small" :min="null" />
              </template>
            </el-table-column>
            <el-table-column label="出仓单号" min-width="130">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.fCkBillNo"
                  style="width: 100%"

                  size="small"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="生产批号"
              prop="fBatchNo"
              min-width="170"
            />
            <el-table-column
              label="生产日期"
              prop="fDate_Sc"
              :formatter="dataFormat2"
              min-width="120"
            />
            <el-table-column
              label="消毒日期"
              prop="fDate_Xd"
              :formatter="dataFormat2"
              min-width="120"
            />
            <el-table-column
              label="追溯号"
              label-class-name="font-color-red"
              min-width="170"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.fRetroactiveNo"
                  style="width: 100%"

                  size="small"
                />
              </template>
            </el-table-column>
            <el-table-column label="有效期(月)" prop="fValidity" />
            <el-table-column label="备注" min-width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fDes" type="textarea" autosize />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-scrollbar>
            <el-table :data="form.procedureMessage" height="100%">
              <el-table-column label="流程步骤" prop="fName" />
              <el-table-column label="处理人" prop="fUserName" />
              <el-table-column label="状态" prop="fState" />
              <el-table-column
                label="日期"
                prop="fDate"
                :formatter="dateFormat"
              />
              <el-table-column label="意见" prop="fOpinion" />
            </el-table>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <el-dialog
      width="80%"
      title="数据选择"
      :visible.sync="innerVisible"
      append-to-body
      :destroy-on-close="true"
    >
      <Inventorys v-model="selInventorys" :visible="innerVisible" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">关闭</el-button>
        <el-button
          type="primary"
          :disabled="!selInventorys.length || saving"
          @click="select3"
        >选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import Inventorys from './Inventorys'

export default {
  inject: ['getMap'],
  components: {
    Inventorys
  },
  data: function() {
    return {
      form: {
        entrys: []
      },
      selInventorys: [],

      tmp: {
        type: 1,
        proId: null,
        proName: null,
        number: 0
      },
      fullName: null,
      rules: {
        fSeal1ID: [{ required: true, message: '必填项', trigger: 'change' }]
      },

      activeName: 'first',
      innerVisible: false,
      loading: false,
      saving: false,
      isNew: false,
      canEdit: true
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {},
  mounted() {
    // console.log(this.$store.state.userInfo, 'this.$store.state.userInfo')
    //  根据权限设置编辑功能
    /*
    const userGrants = this.$store.state.userInfo.userGrants
    userGrants.forEach((val) => {
      if (val.key == '010001003') {
        this.canEdit = val.isGrant
      }
    })
    */
    this.form.fDistributor = this.$store.state.userInfo.name
  },
  methods: {
    sealChange: function(item) {
      this.form.fSealUrl = item.pictureUrl
    },
    async select() {
      this.selInventorys = []
      this.innerVisible = true
    },
    select3: function() {
      var selItems = this.selInventorys
      var entrys = this.form.entrys
      console.log(selItems, 'selItems')
      console.log(entrys, 'entrys')
      for (let j = 0; j < selItems.length; j++) {
        const item = selItems[j]
        // if (!item.fPhQty) continue
        /*
        var found = false
        for (let i = 0; i < entrys.length; i++) {
          const entry = entrys[i]
          if (entry.fOutStockEntryID == item.fOutStockEntryID) {
            // var num = entry.fPhQty || 0
            // num += item.fPhQty
            // entry.fPhQty = num
            found = true
            break
          }
        }
        console.log(found, 'found')
        if (!found) {
          entrys.push(item)
        }*/
        entrys.push(item)
      }
      this.innerVisible = false
    },
    entrysMerge: function(items, number) {
      if (!items.length) return

      const entrys = this.form.entrys

      for (let i = 0; i < entrys.length; i++) {
        const entry = entrys[i]
        for (let j = 0; j < items.length; j++) {
          const item = items[j]
          if (entry.ficItemID == item.ficItemID) {
            entry.fQty += item.fQty * number
            break
          }
        }
      }

      for (let j = 0; j < items.length; j++) {
        var found = false
        const item = items[j]
        for (let i = 0; i < entrys.length; i++) {
          const entry = entrys[i]
          if (entry.ficItemID == item.ficItemID) {
            found = true
            break
          }
        }
        if (!found) {
          entrys.push({
            ficItemID: item.ficItemID,
            fNumber: item.fNumber,
            fName: item.fName,
            fModel: item.fModel,
            fUnit: item.fUnit,
            fQty: item.fQty * number,
            fDes: null
          })
        }
      }
    },
    delRow: function(index) {
      // console.log(index, "index");
      const entrys = this.form.entrys
      entrys.splice(index, 1)
    },

    submit: function() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const flg = await this.confirm('是否提交?')
          if (!flg) return

          this.saving = true
          this.$httpPost('SalesRecordManage/SalesRecord/SalesRecordModify', {
            datalist: JSON.stringify({
              modifyType: this.isNew ? 0 : 1,
              info: this.form
            })
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({
                  path: '/distributorManagement/salesRecord'
                })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        return
      }

      this.loading = true
      const res = await this.$httpPost(
        'SalesRecordManage/SalesRecord/GetSalesRecord',
        {
          fid: id
        }
      ).finally(() => (this.loading = false))
      console.log(res, 'res')
      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
    },
    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dataFormat2: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD ')
    },
    fCustomerChange: function(item, item2) {
      item.fAddress = item2 ? item2.fAddress : null
      item.fName = item2 ? item2.fName : null
      item.fPhone = item2 ? item2.fPhone : null
    },
  }
}
</script>

<style lang="less" >
.sales-modify {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .tools i {
    margin-right: 5px;
    cursor: pointer;
    color: #409eff;
    font-size: 18px;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 170px);
      .el-tab-pane {
        height: calc(100vh - 170px);
      }
    }
  }

}
</style>
